import { IUsersState } from './usersContext';
import { TUsersAction, UsersActionTypes } from './usersActions';

export const usersReducer = (state: IUsersState, action: TUsersAction): IUsersState => {
	switch (action.type) {
		case UsersActionTypes.SET_USERS:
			return {
				...state,
				users: action.payload.users,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case UsersActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case UsersActionTypes.SET_ID_ROLE:
			return {
				...state,
				IDSelectedRole: action.payload.IDSelectedRole,
				currentPage: 1,
			};
		case UsersActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedRole: null,
				currentPage: 1,
			};
		case UsersActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case UsersActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case UsersActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case UsersActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case UsersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case UsersActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
